<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden && !filtersets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-owner" *ngIf="!filters.owner.hidden && !filters.owner.removed" 
                                  class="field-container standard {{filters.owner.invalid ? 'invalid' : ''}} {{filters.owner.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.owner.styles.style"
                                  [ngClass]="filters.owner.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.owner.label + (filters.owner.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.owner.label}}<span *ngIf="filters.owner.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-owners_dd_single 
                                  data-cy="selector"
                                  [type]="filters.owner.control.type"
                                  formControlName="owner"
                                  (displayTextChange)="filters.owner.control.displayText=$event"
                                  [placeholder]="filters.owner.control.placeholder"
                                  [styles]="filters.owner.control.styles"
                                  [tooltip]="filters.owner.control.tooltip"
                                [statusId]="$fields_owner_selector_inParams_statusId"
                                [projectId]="$fields_owner_selector_inParams_projectId"
                              >
                              </Owners-owners_dd_single>
                              <ng-container *ngIf="filters.owner.invalid">
                                <ng-container *ngFor="let error of filters.owner.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-project" *ngIf="!filters.project.hidden && !filters.project.removed" 
                                  class="field-container standard {{filters.project.invalid ? 'invalid' : ''}} {{filters.project.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.project.styles.style"
                                  [ngClass]="filters.project.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.project.label + (filters.project.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.project.label}}<span *ngIf="filters.project.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.project.control.type"
                                  formControlName="project"
                                  (displayTextChange)="filters.project.control.displayText=$event"
                                  [placeholder]="filters.project.control.placeholder"
                                  [styles]="filters.project.control.styles"
                                  [tooltip]="filters.project.control.tooltip"
                                [statusId]="$fields_project_selector_inParams_statusId"
                                [ownerId]="$fields_project_selector_inParams_ownerId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.project.invalid">
                                <ng-container *ngFor="let error of filters.project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-materials" *ngIf="!filters.materials.hidden && !filters.materials.removed" 
                                  class="field-container double {{filters.materials.invalid ? 'invalid' : ''}} {{filters.materials.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.materials.styles.style"
                                  [ngClass]="filters.materials.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.materials.label + (filters.materials.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.materials.label}}<span *ngIf="filters.materials.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Materials-materials_by_project_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.materials.control.type"
                                  formControlName="materials"
                                  (displayTextChange)="filters.materials.control.displayText=$event"
                                  [placeholder]="filters.materials.control.placeholder"
                                  [styles]="filters.materials.control.styles"
                                  [tooltip]="filters.materials.control.tooltip"
                                [projectId]="$fields_materials_selector_inParams_projectId"
                              >
                              </Materials-materials_by_project_dd_multi>
                              <ng-container *ngIf="filters.materials.invalid">
                                <ng-container *ngFor="let error of filters.materials.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouses" *ngIf="!filters.warehouses.hidden && !filters.warehouses.removed" 
                                  class="field-container standard {{filters.warehouses.invalid ? 'invalid' : ''}} {{filters.warehouses.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouses.styles.style"
                                  [ngClass]="filters.warehouses.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouses.label + (filters.warehouses.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouses.label}}<span *ngIf="filters.warehouses.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouses.control.type"
                                  formControlName="warehouses"
                                  (displayTextChange)="filters.warehouses.control.displayText=$event"
                                  [placeholder]="filters.warehouses.control.placeholder"
                                  [styles]="filters.warehouses.control.styles"
                                  [tooltip]="filters.warehouses.control.tooltip"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouses.invalid">
                                <ng-container *ngFor="let error of filters.warehouses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-locations" *ngIf="!filters.locations.hidden && !filters.locations.removed" 
                                  class="field-container standard {{filters.locations.invalid ? 'invalid' : ''}} {{filters.locations.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.locations.styles.style"
                                  [ngClass]="filters.locations.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.locations.label + (filters.locations.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.locations.label}}<span *ngIf="filters.locations.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-locations_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.locations.control.type"
                                  formControlName="locations"
                                  (displayTextChange)="filters.locations.control.displayText=$event"
                                  [placeholder]="filters.locations.control.placeholder"
                                  [styles]="filters.locations.control.styles"
                                  [tooltip]="filters.locations.control.tooltip"
                                [warehouseId]="$fields_locations_selector_inParams_warehouseId"
                                [typeId]="$fields_locations_selector_inParams_typeId"
                              >
                              </Locations-locations_dd_multi>
                              <ng-container *ngIf="filters.locations.invalid">
                                <ng-container *ngFor="let error of filters.locations.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.newGroup1.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.replenishments.hasTabToShow" class="tab" data-cy="tab-replenishments">
              <h2 [className]="tabs.replenishments.active? 'active': ''" (click)="tabs.replenishments.activate()">{{tabs.replenishments.title}}</h2>
            </div>
            <div *ngIf="tabs.replenishment_tasks.hasTabToShow" class="tab" data-cy="tab-replenishment_tasks">
              <h2 [className]="tabs.replenishment_tasks.active? 'active': ''" (click)="tabs.replenishment_tasks.activate()">{{tabs.replenishment_tasks.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_lp.hasTabToShow" class="tab" data-cy="tab-inventory_by_lp">
              <h2 [className]="tabs.inventory_by_lp.active? 'active': ''" (click)="tabs.inventory_by_lp.activate()">{{tabs.inventory_by_lp.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-locations_replenishments_grid *ngIf="tabs.replenishments.active"
              #$tabs_replenishments
              [materialId]="$tabs_replenishments_locations_replenishments_grid_inParams_materialId"
              [warehouseIds]="$tabs_replenishments_locations_replenishments_grid_inParams_warehouseIds"
              [locationId]="$tabs_replenishments_locations_replenishments_grid_inParams_locationId"
              [projectId]="$tabs_replenishments_locations_replenishments_grid_inParams_projectId"
              [ownerId]="$tabs_replenishments_locations_replenishments_grid_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_replenishments')">
              </FootprintManager-locations_replenishments_grid>
              <FootprintManager-replenishment_tasks_grid *ngIf="tabs.replenishment_tasks.active"
              #$tabs_replenishment_tasks
              [materialIds]="$tabs_replenishment_tasks_replenishment_tasks_grid_inParams_materialIds"
              [projectId]="$tabs_replenishment_tasks_replenishment_tasks_grid_inParams_projectId"
              [locationIds]="$tabs_replenishment_tasks_replenishment_tasks_grid_inParams_locationIds"
              [ownerId]="$tabs_replenishment_tasks_replenishment_tasks_grid_inParams_ownerId"
              [warehouseIds]="$tabs_replenishment_tasks_replenishment_tasks_grid_inParams_warehouseIds"
              ($refreshEvent)="refresh(false, false, '$tabs_replenishment_tasks')">
              </FootprintManager-replenishment_tasks_grid>
              <FootprintManager-replenishment_inventory_licenseplate_grid *ngIf="tabs.inventory_by_lp.active"
              #$tabs_inventory_by_lp
              [ownerId]="$tabs_inventory_by_lp_replenishment_inventory_licenseplate_grid_inParams_ownerId"
              [projectId]="$tabs_inventory_by_lp_replenishment_inventory_licenseplate_grid_inParams_projectId"
              [warehouseIds]="$tabs_inventory_by_lp_replenishment_inventory_licenseplate_grid_inParams_warehouseIds"
              [materialIds]="$tabs_inventory_by_lp_replenishment_inventory_licenseplate_grid_inParams_materialIds"
              [locationIds]="$tabs_inventory_by_lp_replenishment_inventory_licenseplate_grid_inParams_locationIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_lp')">
              </FootprintManager-replenishment_inventory_licenseplate_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>